export { default as screenTemplate } from './screen.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/screen/templates/index.ts